// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1C_gj","error":"Textarea_error__3LBzt","readonly":"Textarea_readonly__6lGkg","disabled":"Textarea_disabled__2UmkW"};